import AWS from "aws-sdk";
import { getAWSCredentialsForCurrentUserSession } from "utils/aws";

/**
 * Upload a file to S3 with flexible config
 * @param {Object} options
 * @param {File } options.file - The file to upload
 * @param {string} options.key - Required: full S3 key
 * @param {string} [options.bucket] - Optional override for bucket
 * @returns {Promise<{ url: string, key: string }>} The uploaded file metadata
 */
export const uploadToS3 = async ({ file, key, bucket = process.env.AWS_USER_DOC_BUCKET }) => {
  if (!file || !key) {
    console.error("Both file and key are required");
    return;
  }

  const credentials = await getAWSCredentialsForCurrentUserSession();

  const s3 = new AWS.S3({
    credentials,
    apiVersion: "2006-03-01",
    params: { Bucket: bucket },
  });

  const params = {
    Body: file,
    ContentType: file.type || "application/octet-stream",
    Key: key,
  };

  const upload = await s3.upload(params).promise();

  return upload;
};
